import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  followCursorTooltip: {
    '& .MuiTooltip-tooltip': {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
      fontFamily: theme.typography.fontFamily,
      fontSize: theme.typography.pxToRem(12),
      padding: '4px 8px',
      borderRadius: theme.shape.borderRadius,
      zIndex: theme.zIndex.tooltip,
      pointerEvents: 'none',
      maxWidth: 300,
      boxShadow: theme.shadows[1],
      transform: 'scale(0)',
      transformOrigin: 'top left',
      transition: 'transform 0.15s ease-in-out',
      '&::after': {
        content: '""',
        position: 'absolute',
        width: 0,
        height: 0,
        borderLeft: '6px solid transparent',
        borderRight: '6px solid transparent',
        borderBottom: '12px solid black',
        bottom: '-12px',
        left: '50%',
        transform: 'translateX(-50%)',
      },
    },
    '& .MuiTooltip-tooltip.visible': {
      transform: 'scale(1)',
    },
  },
  disabled: {
    opacity: 0.5,
    cursor: 'not-allowed',
    '& > *': {
      pointerEvents: 'none',
    },
  },
}));
